"use strict";
/*
 * Created on 2019-03-28
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link SelloutTarget} attributes.
 * @author Radek Beran
 */


var SelloutTargetConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutTargetConverter, _DataObjectConverter_);

  function SelloutTargetConverter() {
    _classCallCheck(this, SelloutTargetConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTargetConverter).apply(this, arguments));
  }

  return SelloutTargetConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutTargetConverter = SelloutTargetConverter;